import { createApi } from '@reduxjs/toolkit/query/react';

import { TagTypesEnum } from '@enum/tag-types.enum';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { UnifyApiInterface } from '@interface/unify-api/unify-api.interface';
import { portalQueryAuth } from '@util/api/portal-query-auth';

export const unifyApi = createApi({
  reducerPath: 'unify-api',
  tagTypes: [TagTypesEnum.UnifyApi],
  baseQuery: portalQueryAuth('/unify-api'),
  endpoints: (build) => ({
    loadApis: build.query<ResponseDataInterface<UnifyApiInterface>, undefined>({
      query: () => '/',
      providesTags: [TagTypesEnum.UnifyApi],
    }),
  }),
});
